import { Padrao } from '../generic/padrao';
import { Pessoa } from '../pessoa/pessoa';

export class SuporteTecnico extends Padrao{

    override idTab = 278;

    numero: string;
    funcionarioSol: Pessoa | null = new Pessoa(); 
    prioridade: string;
    titulo: string;
    local: string;
    descricao: string;
    status: string;
    dataSol: Date = new Date();
    dataFinal: Date = new Date();
    descricaoFinal: string;
    classificacao: string;
    area: string;
    patrimonio: string;
}
